import React from 'react';
import CSSModules from 'react-css-modules';
import style from './seperator.scss';

const Seperator = ({ children, ...rest }) => (
  <div styleName={`root size-${rest.size || 'default'}`} style={{ ...rest.style }}>
    <div styleName="inner">
      {children}
    </div>
    <div styleName="extra-content">
      {rest.extraContent}
    </div>
  </div>
);

export default CSSModules(Seperator, style, { allowMultiple: true });


// WEBPACK FOOTER //
// ./src/components/common/seperator.js